
/**
 * 
 * @param {Object} object - the data that needs to be accessible from gtm
 */
export const pushToDataLayer = (object) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(object)
}